import React from 'react';

interface IRubberbandIconProps {
	size?: number;
}

/** Иконка «рамка выделения»: пунктирный квадрат (currentColor). */
const RubberbandIcon: React.FC<IRubberbandIconProps> = ({size = 16}) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<rect
				x="2"
				y="2"
				width="12"
				height="12"
				rx="0.5"
				stroke="currentColor"
				strokeWidth="1.25"
				strokeDasharray="2.5 2"
			/>
		</svg>
	);
};

export default RubberbandIcon;
